import type { ErrorEvent, EventHint } from '@sentry/react';

import get from 'lodash/get';

const rejectErrorMessages: RegExp[] = [
  /Failed to fetch dynamically imported module/v,
  /Element type is invalid\. Received a promise that resolves to: undefined\./v,
  /React ErrorBoundary Error: Element type is invalid\. Received a promise that resolves to: undefined\. Lazy element type must resolve to a class or function\./v,
  /Error: Element type is invalid\. Received a promise that resolves to: undefined\./v,
  /Lazy element type must resolve to a class or function\./v,
  /Cannot read properties of undefined \(reading 'default'\)/v,
  /can't access property ["']default["'], .*_result is undefined/v,
  /Lazy/iv,
  /dynamically imported/iv,
];

export const onHandleRejectSentryErrors = (
  event: ErrorEvent,
  hint: EventHint
) => {
  const targetOriginalException = get(hint, 'originalException.message', '');
  const targetContextException = get(
    hint,
    'captureContext.contexts.react.componentStack',
    ''
  ) as string;

  if (
    rejectErrorMessages.some(
      (errorMessage) =>
        errorMessage.exec(targetOriginalException) ??
        errorMessage.exec(targetContextException)
    )
  ) {
    return null;
  }

  return event;
};
